// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"DashboardHeader_toolbar__26CL2","rangePicker":"DashboardHeader_rangePicker__2_7sR"};